<template>
  <div class="app-center">
    <v-alert
      dismissible
      type="error"
      @input="onClose"
      color="pink lighten-2"
      value="true"
      class="mt-2"
      icon="error_outline"
      transition="scale-transition"
    >
      {{ text }}
    </v-alert>
  </div>
</template>

<script>
export default {
  props: ['text'],
  methods: {
    onClose () {
      this.$emit('dismissed')
    }
  }
}
</script>
